import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { get } from 'lodash';

import { RootState } from '../../store/reducers';
import { isKidAuthSelector } from '../../store/reducers/authSlice';
import { setAnalyticsUserProperties } from '../../lib/analytics';

interface PrivateRouteProps {
  component?: any;
  path: string;
  exact: boolean;
  isParentOnly?: boolean;
  // special route for verification will be allowed with both private and public route.
  isVerifyRoute?: boolean;
}

const PrivateRoute = ({
  component: Component,
  path,
  exact,
  isVerifyRoute,
  isParentOnly = true,
  ...rest
}: PrivateRouteProps): React.ReactElement => {
  const isAuthenticated = useSelector((state) =>
    get(state, 'authReducer.isAuthenticated'),
  );
  const loginReason = useSelector((state) =>
    get(state, 'authReducer.loginReason'),
  );
  const authRoute = loginReason === 'invite' ? '/assign-gift-cards' : '/home';

  const isKid = useSelector((state: RootState) => isKidAuthSelector(state));
  const allowed = !isKid || !isParentOnly;
  const resolvedDefaultRoute = isAuthenticated ? authRoute : '/';
  useEffect(() => {
    setAnalyticsUserProperties(isKid ? 'kid' : 'parent');
  }, [isKid]);
  const shouldAccess = allowed && (isAuthenticated || isVerifyRoute);
  // eslint-disable-next-line no-console
  console.log(
    `route.private[${path}]:${resolvedDefaultRoute}.  shouldAccess: ${shouldAccess}, comp:${Component.name}`,
  );
  return (
    <Route
      exact={exact}
      {...rest}
      path={path}
      render={(props) =>
        shouldAccess ? (
          <Component {...props} />
        ) : (
          <Redirect to={resolvedDefaultRoute} />
        )
      }
    />
  );
};

export default React.memo(PrivateRoute);
